import { api_get, PROYECT } from "services/api";

export const fetchNotes = async (idUnit) => {
  if(!idUnit) return console.log('idUnit', idUnit);
  const url = `${process.env.REACT_APP_URL}${PROYECT}/inventory-gas-movements/notes-with-condonation/${idUnit}`
  const response = await api_get(url)
  const responseLabel = response.map(item => ({
    ...item,
    value: item?.id,
    label: `F-${item?.folio} - $${item?.total}`
  }))
  return responseLabel
}